import { createAsyncThunk } from '@reduxjs/toolkit'
import User, { RoleType } from '../../../models/User'
import authService from '../../../services/auth.service'
import { setChangePassAndTxn } from '../common/commonSlice'
import { updateMessage, userUpdate } from './loginSlice'

export const loginAction = createAsyncThunk(
  'user/login',
  async (user: User, { rejectWithValue, dispatch }) => {
    const successCallback = (res: any) => {
      dispatch(userUpdate(res.data.data))
      if (res.data.data?.changePassAndTxn !== undefined) {
        dispatch(setChangePassAndTxn(!!res.data.data.changePassAndTxn))
      }
      dispatch(updateMessage({ status: true }))
      dispatch(getUserInfoAction({} as User))
      // Store last login time
      const now = new Date();
      const formattedTime = now.toLocaleDateString('en-GB', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      }) + ' ' + now.toLocaleTimeString('en-US', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: true
      });
      localStorage.setItem('lastLoginTime', formattedTime);
      return res.data
    }
    if (user.admin) {
      return authService
        .loginAdmin(user)
        .then(successCallback)
        .catch((e) => {
          return rejectWithValue(e.response.data.message)
        })
    }
    return authService
      .login(user)
      .then(successCallback)
      .catch((e) => {
        return rejectWithValue(e.response.data.message)
      })
  },
)

export const getUserInfoAction = createAsyncThunk(
  'user/user-info',
  async (user: User, { rejectWithValue, dispatch }) => {
    if (authService.getRefreshToken()) {
      return authService
        .getUser()
        .then((res: any) => {
          const u = res.data?.data?.user
          if (u?.changePassAndTxn !== undefined) {
            dispatch(setChangePassAndTxn(!!u.changePassAndTxn))
          }
          return res.data
        })
        .catch((e: any) => {
          return rejectWithValue(e.response.data.message)
        })
    }
    return rejectWithValue('Token not exist')
  },
)
